
const ROUTERS = {
    "java":"java",
    "python":"python",
    "c":"c-language",
    "vue":"vue",
    "css":"css",
    "jquery":"jquery",
    "js":"js-language",
    "mysql":"mysql",
    "sqlite":"sqlite",
    "mongodb":"mongodb",
 
    "数据库":"data-base",
    "前端":"fontend",
    "后端":"backend",
    "前沿技术":"advance",

    "深度学习":"deep-learn",
    "大数据":"big-data",
    "数据分析":"data-analysis",

    "学习笔记":"notes",
    "解决方案":"solution",
    "转载":"collection",
    "个人随笔":"secret",

    "职业":"profession",
    "诗词歌赋":"shi-ci-ge-fu",
}

export default ROUTERS